
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "Modal930293243",
      {"classes":{"root":"Modal930293243__root","modal":"Modal930293243__modal","overlay":"Modal930293243__overlay"},"vars":{"wix-color-5":"--wix-color-5","wut-bg-color":"--wut-bg-color","wut-text-color":"--wut-text-color","wut-disabled-color":"--wut-disabled-color","wut-placeholder-color":"--wut-placeholder-color","wut-main-cta-color":"--wut-main-cta-color","wut-secondary-cta-color":"--wut-secondary-cta-color","wut-input-border-color":"--wut-input-border-color","wut-input-hover-and-focus-border-color":"--wut-input-hover-and-focus-border-color","wut-selection-text-bg-color":"--wut-selection-text-bg-color","wut-meta-data-color":"--wut-meta-data-color","wut-clear-button-bg-color":"--wut-clear-button-bg-color"},"stVars":{},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  